<template>
  <div class="image-wrap">
    <img
      v-show="profilePhoto"
      class="img"
      :src="photoComp"
      crossOrigin="Anonymous"
    />
  </div>
</template>
<script>
import auth from "../../../auth";
import store from "../../../data/store";

export default {
  name: "ProfilePhotoView",
  props: {
    photoIdProp: String,
    index: Number,
  },
  data() {
    return {
      filePath: "",
      profilePhoto: {
        Path: "",
        SitterPhotoId: 0,
        Type: "",
      },
      uploadedImageSrc: "",
    };
  },
  created: function () {
    var self = this;
    $.ajax(
      "https://www.dupaws.com/services/api/getSitterProfilePhoto/" +
        self.photoIdProp,
      {
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        crossDomain: true,
        success: function (data) {
          self.profilePhoto = data;
        },
        error: function () {
          console.log(
            'Couldnt get sitter profile photo "api/getSitterProfilePhoto"'
          );
        },
      }
    );
  },
  computed: {
    photoComp: function () {
      self = this;
      if (self.profilePhoto.Path)
        return "https://www.dupaws.com/services/" + self.profilePhoto.Path;
    },
    photoIdComp: function () {
      return this.profilePhoto.SitterPhotoId;
    },
  },
};
</script>
<style scoped>
.image-wrap {
  max-width: 100px;
  margin: 2px;
  overflow: hidden;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  min-height: 100px;
  max-height: 200px;
  min-width: 90px;
}

.img {
  width: 100%;
  height: 100%;
  transition: all 1s ease-in;
}

.image-class:hover img {
  transform: scale(1.4);
  transition: all 1s ease-in;
  filter: brightness(0.5);
}
</style>



// WEBPACK FOOTER //
// ProfilePhotoView.vue?7cc621ca